export const EMPLOYEE_ROLES = {
    OWNER: "owner",
};

/**
 * Роли компании из таблицы `roles` — бэкенд отдаёт их строкой в `company_roles`.
 * Значения приходят на русском, поэтому сравнение идёт по строке.
 */
export const COMPANY_ROLES = {
    SHIPPER: "Грузоотправитель",
    CARRIER: "Перевозчик",
    FORWARDER: "Экспедитор",
};

export const GROUP_ROLES = {
    USER: "412b8600-2b00-4a51-93f1-21fe2edf73c1",
    ADMIN: "3406a36b-89b2-455e-a01e-44d754a6d802",
};
